import {combineReducers} from 'redux';
import commonPageData from './common-page-data';
import cyberSourceData from './cyber-source-data';
import optileData from './optile-data';
import featureFlags from './feature-flags';
import cardSelection from './saved-cards';


export default combineReducers({
    commonPageData,
    cyberSourceData,
    optileData,
    featureFlags,
    cardSelection
});
